// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"51":"6dd1f36a07e17805","65":"21e3b5328903de92","1037":"25db1d56f38c8d6b","5875":"ec507f768da01603","7871":"a793baa956b028ec"}[chunkId] + ".css";
};